<template>
  <UICard title="AI tools">
    <UICheckbox v-model="aIAgent" label="Enable AI agents" />
  </UICard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useSettingsStore } from '@/store/settings'

import { UICard } from '@ui/core'
import { UICheckbox } from '@ui/controllers'

const settingsStore = useSettingsStore()

const aIAgent = computed<boolean>({
  get() {
    return settingsStore.getAIAgent
  },
  set(value) {
    settingsStore.setAIAgent(value)
  },
})
</script>
